import type { StandardI18nProvider } from 'I18n/init/providers/createStandardI18nProvider';

export interface HeartbeatAPI {
  isActive: (thresholdMs?: number) => boolean;
  readonly lastActivity: number;
  onNewActivity: (handler: () => void) => () => void;
  onNewActivityOnce: (handler: () => void) => () => void;
}

/**
 * Interface for the Whisper API that will be exposed at window level
 */
export interface Whisper {
  debug: (enabled: boolean) => void;
  isDebugMode: () => boolean;
  shutdown: () => void;
  get(name: string): unknown;
  get<T>(name: string): T;
  getPortalId: () => number | undefined;
  captureMessage: (message: string, options?: { [key: string]: any }) => void;
  captureError: (
    message: string,
    error: any,
    options?: { [key: string]: any }
  ) => void;
  i18n: {
    i18nProvider: StandardI18nProvider;
    setupI18n: (
      options: Parameters<StandardI18nProvider['setLocale']>[0]
    ) => Promise<void>;
  };
  version: string;
}

export const getWhisper = (): Whisper | undefined => {
  const { Whisper } = window as any;
  return Whisper?.version ? Whisper : undefined;
};
